import { api } from './client';

/**
 * Update the authenticated user's profile.
 * Backend: PATCH /users/me
 * Accepts: { name, timezone, locale }
 */
export async function updateUserProfile(updates) {
  return api.patch('/users/me', updates);
}
